import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Layered detail. Native <details> so the content is always in the DOM for
 * crawlers and AI assistants, but an anxious reader isn't confronted by it.
 */
const SedationDisclosure = ({ heading, summary, tid, children }) => (
  <details className="group rounded-2xl border border-[#006A71]/15 bg-white transition-shadow duration-300 open:shadow-[0_18px_50px_-30px_rgba(0,106,113,0.45)] motion-reduce:transition-none" data-testid={tid}>
    <summary className="flex cursor-pointer list-none items-start justify-between gap-5 px-6 py-6 sm:px-9 sm:py-8 [&::-webkit-details-marker]:hidden">
      <span className="block">
        <h2 className="text-xl md:text-2xl font-semibold text-rabbit">{heading}</h2>
        {summary && <span className="mt-2 block text-sm text-chocolate-malt/75">{summary}</span>}
      </span>
      <span className="mt-1 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-[#006A71]/25 text-[#006A71] transition-colors duration-200 group-hover:bg-[#006A71]/5 motion-reduce:transition-none">
        <ChevronDown className="h-5 w-5 transition-transform duration-300 group-open:rotate-180 motion-reduce:transition-none" strokeWidth={1.75} aria-hidden="true" />
      </span>
    </summary>
    <div className="px-6 pb-9 sm:px-9">{children}</div>
  </details>
);

export default SedationDisclosure;
